import { Icon, TextLink } from '@petsmart-ui/sparky';

type PromoItemProps = {
    readonly promoText: string;
    readonly onDetailsClick: () => void;
    readonly hasDetails: boolean;
};

export default function PromoItem({
    promoText,
    onDetailsClick,
    hasDetails,
}: PromoItemProps) {
    return (
        <div
            className="product-promotions-item"
            data-testid="product-promotions-item"
        >
            <div className="product-promotions-item-callout">
                <Icon name="tag" data-testid="promo-icon" />
                {promoText}
            </div>
            {hasDetails && (
                <div className="product-promotion-details">
                    <TextLink
                        onClick={onDetailsClick}
                        className="promo-details"
                    >
                        Details
                    </TextLink>
                </div>
            )}
        </div>
    );
}
